import { MutableRefObject, useState, useEffect } from 'react';

export interface ElementSizeType {
    width?: number;
    height?: number;
}
// Hook
function useElementSize(ref: MutableRefObject<null>) {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState<ElementSizeType>({
        width: undefined,
        height: undefined,
    });
    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // @ts-ignore
            // console.log(ref.current, ref.current?.offsetWidth);
            // Set window width/height to state
            setWindowSize({
                // @ts-ignore
                width: ref.current?.offsetWidth,
                // @ts-ignore
                height: ref.current?.offsetHeight,
            });
        }
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, [ref]); // Empty array ensures that effect is only run on mount
    return windowSize;
}

export default useElementSize;
